<div
  class="px-16 py-24 deleted-account"
  data-testid="deleted-click"
  (click)="goTo()">
  <h5 class="color-psr-text-color upper fw-bold f16">
    {{ 'login.deletedAccount.title' | translate }}
  </h5>
  <p class="f13 mb-0">
    {{ 'login.deletedAccount.descOne' | translate }} {{ company }}
    {{ 'login.deletedAccount.descOneContinue' | translate }}
  </p>
  <p class="f13 mt-0 mb-8">
    {{ 'login.deletedAccount.descTwo' | translate }}
    <a href="mailto:{{ 'login.deletedAccount.email' | translate }}">{{
      'login.deletedAccount.email' | translate
    }}</a>
    {{ 'login.deletedAccount.descThree' | translate }}
    <a href="tel:{{ 'login.deletedAccount.phoneNumber' | translate }}">{{
      'login.deletedAccount.phoneNumber' | translate
    }}</a>
  </p>
</div>
